import React, { useState } from 'react';
import { signIn, signUp } from '../AuthContext';

export default function Login() {
  const [mode, setMode] = useState('signin'); // 'signin' | 'signup'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === 'signup') {
        await signUp(email, password);
      } else {
        await signIn(email, password);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cs-modal" style={{ maxWidth: 400 }}>
      <div className="cs-brand" style={{ fontSize: 28, marginBottom: 6 }}>
        {process.env.REACT_APP_APP_NAME || 'starter'}
      </div>
      <h2 style={{ fontSize: 22, marginTop: 0 }}>
        {mode === 'signup' ? 'Create account' : 'Sign in'}
      </h2>

      {error && (
        <div className="cs-empty" style={{ padding: 12, marginBottom: 14, color: 'var(--danger)' }}>
          {error}
        </div>
      )}

      <form onSubmit={submit}>
        <div className="cs-field">
          <label>Email</label>
          <input
            type="email"
            className="cs-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </div>
        <div className="cs-field">
          <label>Password</label>
          <input
            type="password"
            className="cs-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            autoComplete={mode === 'signup' ? 'new-password' : 'current-password'}
          />
        </div>
        <button type="submit" className="cs-btn cs-btn-primary" style={{ width: '100%' }} disabled={busy}>
          {busy ? 'Please wait…' : mode === 'signup' ? 'Create account' : 'Sign in'}
        </button>
      </form>

      <div style={{ textAlign: 'center', marginTop: 16 }}>
        <button
          className="cs-btn cs-btn-ghost cs-btn-sm"
          onClick={() => setMode(mode === 'signup' ? 'signin' : 'signup')}
        >
          {mode === 'signup'
            ? 'Already have an account? Sign in'
            : 'Need an account? Create one'}
        </button>
      </div>
    </div>
  );
}
